import _ from 'lodash';
import {Component, Module} from 'app/decorators';


import tpl from './acres.calc.control.html';



@Module({
    name: "app.directives.acres.calc.control",
    modules: []
})
@Component({
    selector: 'blnd-acres-control',
    bindings: {
        ngModel: '=',
        ngChange: '&',
    },
    template: tpl,
})
export default class C {

    constructor ($timeout) {
        "ngInject";
        this.$timeout = $timeout;
    }

    toggle () {
        this.ngModel = !this.ngModel;
        this.ngChange({isChanged: this.ngModel});
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/acres.calc.control.js